import React from 'react'
import Lottie from 'lottie-react'
import * as animationData from '@public/lottie/idea.json'

export const IdeaLottie = () => {
	return (
		<Lottie
			animationData={animationData}
			loop={true}
			style={{
				width: 300,
				height: 300,
			}}
			rendererSettings={{ preserveAspectRatio: 'xMidYMid slice' }}
		/>
	)
}
